var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 60,
    rx: 30,
    fill: "#1C1C1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1514 56.1787C16.0156 56.1787 4.37012 44.5332 4.37012 30.373C4.37012 16.2373 15.9912 4.5918 30.1514 4.5918C44.2871 4.5918 55.9326 16.2373 55.9326 30.373C55.9326 44.5332 44.3115 56.1787 30.1514 56.1787ZM22.4609 40.8711C23.3154 40.8711 23.999 40.5781 24.5361 40.041L30.1514 34.4014L35.791 40.041C36.3281 40.5781 37.0361 40.8711 37.8662 40.8711C39.4531 40.8711 40.6738 39.626 40.6738 38.0391C40.6738 37.3066 40.3809 36.623 39.8193 36.0859L34.1553 30.4219L39.8438 24.709C40.4053 24.1719 40.6738 23.4883 40.6738 22.7559C40.6738 21.1934 39.4531 19.9727 37.8906 19.9727C37.0605 19.9727 36.4258 20.2168 35.8398 20.8027L30.1514 26.4424L24.5117 20.8027C23.9502 20.2656 23.3154 19.9971 22.4609 19.9971C20.8984 19.9971 19.6777 21.1934 19.6777 22.8047C19.6777 23.5127 19.9707 24.1963 20.5078 24.7334L26.1963 30.4219L20.5078 36.1104C19.9707 36.623 19.6777 37.3311 19.6777 38.0391C19.6777 39.626 20.8984 40.8711 22.4609 40.8711Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWhite);
export default __webpack_public_path__ + "static/media/xWhite.e407ea2c3a31278de95968706edc16c1.svg";
export { ForwardRef as ReactComponent };